<!-- eslint-disable no-trailing-spaces -->
<!-- eslint-disable dot-notation -->
<template>
    <div class="d-flex main-container">
      <!-- Side Menu -->
      <!-- In your main component template, replace the side menu section with: -->
       <div class="side-nav">
          <side-menu 
            :active-item="activeMenu" 
            @menu-change="handleMenuChange"
          />
      </div>
  
      
      <!-- Main Content -->
      <div class="main-content">
        <b-container class="touchpoint-dashboard">
          <b-card class="dashboard-card content-card">
      
            <!-- Data Table Section -->
            <b-card-body>
              <!-- Replace the current flex container with Bootstrap grid -->
              <div class="row mb-0 h-100" name="data-squares">
                <div class="col-xl-4 col-lg-6 col-12 mb-3">
                  <div class="p-3 d-flex flex-column h-100 data-square">
                    <!-- Date Range -->
                    <div class="flex row justify-content-between pr-3 pl-3">
                      <h5 class="mb-3">Filter</h5>

                      <div>
                        <b-button 
                          @click="subtractDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleLeft" class="text-white"/>
                        </b-button>
                        
                        <b-button 
                          @click="addDay"
                          variant="light"
                          style="background-color: dimgray; height: 2em; font-weight: bolder;"
                          class="b-flex justify-content-between align-items-center">
                          <font-awesome-icon style="height: 100%; width: 100%;" :icon="icons.faAngleRight" class="text-white"/>
                        </b-button>
                      </div>

                    </div>
                    
                    <div class="mb-3">
                      <label for="date-range-picker" class="font-weight-bold d-block mb-2 text-muted"><h6>Date Range:</h6></label>
                        <b-input-group class="d-flex flex-row gap-2">
                          <b-form-datepicker 
                            id="start-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.startDate"
                            :max="filters.endDate"
                            class="w-50"
                          ></b-form-datepicker>
                          <b-form-datepicker 
                            id="end-date-picker" 
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric', weekday: 'long' }"
                            nav-button-variant="dark"
                            selected-variant="secondary"
                            v-model="filters.endDate"
                            :min="filters.startDate"
                            class="w-50"
                          ></b-form-datepicker>
                        </b-input-group>
                    </div>

                                        <!-- Location -->
                    <div class="mb-3">
                      <label for="location-select" class="font-weight-bold d-block mb-2 text-muted"><h6>Location:</h6></label>
                      <b-form-select 
                        id="location-select" 
                        v-model="filters.location" 
                        :options="myLocations" 
                        class="w-100"
                        no-flip

                      ></b-form-select>
                    </div>

                    <!-- Age -->
                    <div class="d-flex flex-row gap-3">
                      <div class="mb-3 w-50 pr-2">
                        <label for="age-select" class="font-weight-bold d-block mb-2 text-muted"><h6>Previous:</h6></label>
                        <b-form-input 
                          id="age-select" 
                          v-model="filters.age" 
                          type="number"
                          min="1"
                          max="365"
                          class="w-100"
                        ></b-form-input>
                      </div>

                      <!-- Interval -->
                      <div class="mb-3 w-50 pr-2">
                        <label for="interval-select" class="font-weight-bold d-block mb-2 text-muted"><h6>Interval:</h6></label>
                        <b-form-select 
                          id="interval-select" 
                          v-model="filters.interval" 
                          :options="myIntervals" 
                          class="w-100"
                        ></b-form-select>
                      </div>
                    </div>


                    <!-- Go Button - Using mt-auto to push to bottom and flex-grow for spacing -->
                    <div class="mt-auto pt-3">
                      <b-button 
                        variant="success"
                        class="w-100"
                        @click="fetchData" 
                        :disabled="loading"
                        size="md"
                      >
                        <i class="fas fa-sync-alt me-2"></i>
                        {{ loading ? 'Loading...' : 'Fetch Data' }}
                      </b-button>
                    </div>
                  </div>
                </div>
                
                <div class="col-xl-8 col-lg-6 col-12 mb-3">

                  <div class="sales-data">
                    <div class="p-3 h-100">
                      <b-button 
                        @click="exportToCSV"
                        variant="dark"
                        style="top: 1em; right: 1em; width: 5em; height: 2em; font-weight: bolder;"
                        class="position-absolute d-flex justify-content-between align-items-center px-2">
                        CSV
                        <font-awesome-icon :icon="icons.faDownload" class="text-white"/>
                      </b-button>

                      <h5 class="mb-3">Compare:</h5>
                      <div class="p-2 border rounded bg-white shadow-sm mb-2" style="width: 100%; min-height: 100px;">
                        <div class="d-flex flex-column">
                          
                          <div class="position-relative mt-2">
                            <div class="position-relative d-flex align-items-center mt-2 justify-content-center" style="height: 4px; background-color: #ffd1b3; margin: 0 45px; border-radius: 2px;">
                              
                              <div class="position-absolute d-flex align-items-center justify-content-center shadow-sm" 
                                  style="left: -45px; min-width: 90px; height: 28px; background-color: #fff3e6; border: 2px solid #ffd1b3; border-radius: 50px; color: #000; font-size: 0.7rem; font-weight: 600;">
                                {{ timelineData.selectionStart }}
                              </div>

                              <span class="badge position-absolute" 
                                    style="background-color: #fff; color: rgb(82, 44, 10); font-size: 0.7rem; border: 1px solid #ffd1b3; padding: 2px 8px; z-index: 2;">
                                Current Selection
                              </span>

                              <div class="position-absolute d-flex align-items-center justify-content-center shadow-sm" 
                                  style="right: -45px; min-width: 90px; height: 28px; background-color: #fff3e6; border: 2px solid #ffd1b3; border-radius: 50px; color: #000; font-size: 0.7rem; font-weight: 600;">
                                {{ timelineData.selectionEnd }}
                              </div>
                            </div>
                          </div>

                          <div class="position-relative" style="margin-top: 2em;">
                            <div class="position-relative d-flex align-items-center justify-content-center" style="height: 4px; background-color: #d1c4e9; margin: 0 45px; border-radius: 2px;">
                              
                              <div class="position-absolute d-flex align-items-center justify-content-center shadow-sm" 
                                  style="left: -45px; min-width: 90px; height: 28px; background-color: #fcfaff; border: 2px solid #d1c4e9; border-radius: 50px; color: #000; font-size: 0.7rem; font-weight: 600;">
                                {{ timelineData.lookbackStart }}
                              </div>

                              <span class="badge position-absolute" 
                                    style="background-color: #fff; color: #4a148c; font-size: 0.7rem; border: 1px solid #d1c4e9; padding: 2px 8px; z-index: 2;">
                                Previous (-{{ filters.age }} {{ filters.interval }}s)
                              </span>

                              <div class="position-absolute d-flex align-items-center justify-content-center shadow-sm" 
                                  style="right: -45px; min-width: 90px; height: 28px; background-color: #fcfaff; border: 2px solid #d1c4e9; border-radius: 50px; color: #000; font-size: 0.7rem; font-weight: 600;">
                                {{ timelineData.lookbackEnd }}
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>



                      <b-table
                        striped
                        hover
                        :items="filteredData"
                        :fields="fields"
                        :filter="filters.search"
                        :busy="loading"
                        show-empty
                        class="sales-table fixed-layout-table"
                      >
                        <template #table-busy>
                          <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>

                        <template #empty>
                          <div class="text-center text-muted">
                            <h4>No Orders Available</h4>
                            <p>Please refresh or change search parameters to load new orders</p>
                          </div>
                        </template>

                        <template #cell(In_Store)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                        <template #cell(Chicken_Shack_App)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}  
                        </template>
                        <template #cell(Mobile_App)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                        <template #cell(Doordash)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                        <template #cell(Uber)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                        <template #cell(Grubhub)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                        <template #cell(Total_Sales)="data">
                            ${{ data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </template>
                      </b-table>

                      <div class="d-flex w-100 mt-2" style="background-color: white; border-radius: 0.5em; ">
                          
                          <div class="d-flex flex-grow-1">
                              <div style="width: 10%;"></div> 
                              <div v-for="stat in comparisonStats" :key="stat.label" style="width: 13%; background-color: #fff;">
                                  <div :class="['mx-1 py-1 rounded border d-flex flex-column align-items-center', stat.isUp ? 'border-success text-success' : 'border-danger text-danger']" 
                                      style="font-size: 0.75rem; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important; font-weight: bold;">
                                      <span>{{ stat.isUp ? '+' : '' }}{{ stat.percent }}%</span>
                                      <span style="opacity: 0.8; font-size: 0.6rem;">({{ stat.diff > 0 ? '+' : '' }}${{ stat.diff.toLocaleString() }})</span>
                                  </div>
                              </div>
                          </div>
                      </div>

                      
                      
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-container>
      </div>
    </div>
  </template>
  
<!-- eslint-disable no-trailing-spaces -->
<script>
    import { DateTime } from "luxon";
    import AuthMixin from "../../mixins/auth.mixin";
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import SideMenu from '@/components/admin-nav.vue';
    import { Api } from "shared/api";
    import { apiHandler } from "@/services/api-handler";

    import { 
        faDollarSign, 
        faTruck, 
        faBicycle, 
        faStore, 
        faSyncAlt,
        faTrash,
        faCheckCircle,
        faChartLine,
        faDownload,
        faExclamationTriangle,
        faArrowUp,
        faArrowDown,
        faAngleRight,
        faAngleLeft
    } from '@fortawesome/free-solid-svg-icons';


    export default {
        name: 'tp-compare',
        mixins: [AuthMixin],
        components: {
        SideMenu,
        FontAwesomeIcon
    },
    data() {
    const now = DateTime.now().setZone('America/New_York');
    const previousSunday = now.set({ weekday: 7 }).minus({ weeks: 2 });


    const lastDay = previousSunday.plus({ days: 6 });

    // Helper function to format date
    const formatDate = (date) => {
        return date.toFormat('yyyy-MM-dd');
    };

    return {
        loading: false,
        connectionTested: false,
        connectionError: null,
        tableData: [],
        activeMenu: 'Compare',
        filters: {
            startDate: formatDate(previousSunday),
            endDate: formatDate(lastDay),
            location: 'loading',
            age: 1,
            interval: 'week',
            query: 'Menu Item Matrix'    ,
            search: ''       
        },
        myLocations: [],
        myIntervals: [
            { value: 'day', text: 'Day' },
            { value: 'week', text: 'Week' },
            { value: 'month', text: 'Month' },
            { value: 'year', text: 'Year' }
        ],
        locationOptions: [
            { value: 'admin', text: 'All Locations', number: null },
            { value: 'cs001~6a6861cee116a411daf7257b768684f11', text: 'Royal Oak - 11 Mile', number: '1' },
            { value: 'cs002~c99923bf0c29c39e512f9cd5a1ccffb71', text: 'Royal Oak - Woodward', number: '2' }, 
            { value: 'cs003~53c0e59c5fb5a4b676717978476b2cbb1', text: 'Warren - Ryan', number: '3' },
            { value: 'cs004~2c16af0ed018da5378e45c0d933d2abe1', text: 'Warren - Schoenherr', number: '4' },
            { value: 'cs005~b46e2e33bd41887baa27551ff98621a61', text: 'New Baltimore', number: '5' },
            { value: 'cs006~9066e49435610ebbdaa8df630b5df3761', text: 'Grosse Pointe', number: '6' },
            { value: 'cs007~f809e2deca9605fab245518e0340dd3b1', text: 'St. Clair Shores', number: '7' },
            { value: 'cs008~57296834507ff8a37faf4f393bbddde51', text: 'Lincoln Park', number: '8' },
            { value: 'cs009~1f38264643f0c3890262073e3b97588c1', text: 'Sterling Heights', number: '9' },
            { value: 'cs010~cc0cab7dc43218119bb8cf2f298860611', text: 'Westland', number: '10' },
            { value: 'cs011~703345b217d1b56b60b447a1b6ff5a441', text: 'Macomb Township', number: '11' },
            { value: 'cs012~52c1952e9adbb62d1acec487b8b568551', text: 'Rochester', number: '12' },
            { value: 'cs013~ea4602ebe1e3dd4066e2369bc91f34f11', text: 'Detroit', number: '13' },
            { value: 'cs014~b9c028ce92edde3680eacfee75b701ae1', text: 'Clarkson', number: '14' },
            { value: 'cs015~4e5ece70d119ca0bb8f94502e95ac1191', text: 'Clawson', number: '15' },
            { value: 'cs016~ed873ecd067cd8608e6c19b1bbb36b341', text: 'Southfield', number: '16' },
            { value: 'cs017~8d3b502ef4ddc533b78c6310e43550601', text: 'Livonia', number: '17' },
            { value: 'cs018~cfdf796adf8452b0a55654a6530a25041', text: 'Riverview', number: '18' },
            { value: 'cs019~4d6704df7f00688bb3df6a8ddc1b93441', text: 'Clinton Township', number: '19' },
            { value: 'cs020~3556ff4772b8dbd30303cc5b4c3889a31', text: 'Shelby Township', number: '20' },
            { value: 'cs021~ff5907d6686f7d8267d2fd7b3f134da31', text: 'Brownstown', number: '21' },
            { value: 'cs022~6410a2fcaf82c9ba914ee9569e9832761', text: 'Bloomfield Township', number: '22' },
            { value: 'cs023~cf16d220ae79e94f7cfa13d5847cda311', text: 'Ypsilanti', number: '23' },
            { value: 'cs024~90cd7a9e6c3e34a8a15203dd8f5cfb211', text: 'Grand Blanc', number: '24' },
            { value: 'cs025~f597f3f279b81ebd354cab7ab184f68a1', text: 'Sterling Heights - 18 Mile', number: '25' },
            { value: 'cs026~6e124a7877a402b609e2d9b3da2dd2541', text: 'Oxford', number: '26' }        ],
        fields: [
        {
            key: 'Period',
            label: 'Period',
            class: 'text-left p-2',
            thStyle: { borderRadius: '10px 0px 0px 0px',width: '9%', borderBottom: '3px solid orange', borderTop: '0px', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Order_Count',
            label: 'Orders',
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid purple', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' },
        },
        {
            key: 'In_Store',
            label: 'In Store',
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid purple', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Chicken_Shack_App',
            label: 'Online', 
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid grey', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Doordash',
            label: 'Doordash',
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid grey', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Uber',
            label: 'Uber',
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid grey', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Grubhub',
            label: 'Grubhub',
            class: 'text-left p-2',
            thStyle: { width: '11%', borderBottom: '3px solid grey', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        },
        {
            key: 'Total_Sales',
            label: 'Total',
            class: 'text-left p-2',
            thStyle: { borderRadius: '0px 10px 0px 0px', width: '11%', borderBottom: '3px solid green', borderTop: '0px', borderLeft: '1px solid lightgrey', backgroundColor: 'ghostwhite' }
        }
        ],
        icons: {
        faDollarSign,
        faTruck, 
        faBicycle, 
        faStore, 
        faSyncAlt,
        faTrash,
        faCheckCircle,
        faExclamationTriangle,
        faChartLine,
        faDownload,
        faArrowUp,
        faArrowDown,
        faAngleRight,
        faAngleLeft
      },
    };
    },
    computed: {
    comparisonStats() {
        if (!this.tableData || this.tableData.length < 2) return [];

        // Explicitly find rows by Period name instead of array index
        const current = this.tableData.find(row => row.Period === 'Current');
        const prior = this.tableData.find(row => row.Period === 'Historical');

        // Safety check in case one period is missing
        if (!current || !prior) return [];

        const statConfig = [
            { label: 'Orders', key: 'Order_Count' },
            { label: 'In Store', key: 'In_Store' },
            { label: 'Online', key: 'Chicken_Shack_App' },
            { label: 'Doordash', key: 'Doordash' },
            { label: 'Uber', key: 'Uber' },
            { label: 'Grubhub', key: 'Grubhub' },
            { label: 'Total', key: 'Total_Sales' }
        ];

        return statConfig.map(item => {
            const isOrders = item.label === 'Orders';
            
            // Use the value directly (the SQL already handles / 100)
            const curVal = parseFloat(current[item.key]) || 0;
            const priVal = parseFloat(prior[item.key]) || 0;

            const diff = curVal - priVal;
            
            let percent = 0;
            if (priVal !== 0) {
                percent = (diff / priVal) * 100;
            } else if (curVal > 0) {
                percent = 100;
            }

            return {
                label: item.label,
                // Keep precision for math, handle formatting in the template
                diff: isOrders ? Math.round(diff) : diff,
                percent: percent.toFixed(2), // Removed Math.abs so you can show negative change if needed
                isUp: diff >= 0
            };
        });
    },
    timelineData() {
        const start = DateTime.fromISO(this.filters.startDate);
        const end = DateTime.fromISO(this.filters.endDate);
        
        // Define the shift amount based on user input (e.g., 5 days, 1 month)
        const shiftAmount = { [this.filters.interval + 's']: this.filters.age };

        // Shift the entire range back
        const lbStart = start.minus(shiftAmount);
        const lbEnd = end.minus(shiftAmount);

        return {
            selectionStart: start.toFormat('LLL dd, yy'),
            selectionEnd: end.toFormat('LLL dd, yy'),
            lookbackStart: lbStart.toFormat('LLL dd, yy'),
            lookbackEnd: lbEnd.toFormat('LLL dd, yy')
        };
      },
    openOrdersCount() {
        return this.filteredData.filter(item => item.status !== 'Fulfilled' && item.status !== 'Closed').length;
    },

    // 2. Average revenue (total settlement / number of orders)
    averageOrderRevenue() {
        if (!this.filteredData.length) return 0;
        const total = this.filteredData.reduce((sum, item) => sum + (item.total_settlement || 0), 0);
        return (total / this.filteredData.length) / 100; // Dividing by 100 for cents-to-dollars
    },

    // 3. Find the closest upcoming "order_due" date and calculate time remaining
    nextOrderDueText() {
        const now = new Date();
        const futureOrders = this.filteredData
            .map(item => new Date(item.order_due))
            .filter(date => date > now)
            .sort((a, b) => a - b);

        if (!futureOrders.length) return "No upcoming orders";

        const diffInMs = futureOrders[0] - now;
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
            return `${diffInDays}d ${diffInHours % 24}h`;
        }
        return `${diffInHours}h ${Math.floor((diffInMs / (1000 * 60)) % 60)}m`;
    },
    // Get filtered data based on search
    filteredData() {
        if (!this.filters.search) {
        return this.tableData;
        }
        
        const searchTerm = this.filters.search.toLowerCase();
        return this.tableData.filter(item => {
        const location = item.Location ? item.Location.toLowerCase() : '';
        const inStore = item['In Store'] ? item['In Store'].toString() : '';
        const chickenShackApp = item['Chicken Shack App'] ? item['Chicken Shack App'].toString() : '';
        const mobileApp = item['Mobile App'] ? item['Mobile App'].toString() : '';
        const totalSales = item['Total Sales'] ? item['Total Sales'].toString() : '';
        
        return (
            location.includes(searchTerm) ||
            inStore.includes(searchTerm) ||
            chickenShackApp.includes(searchTerm) ||
            mobileApp.includes(searchTerm) ||
            totalSales.includes(searchTerm)
        );
        });
    },

    // Total sales across all locations and origins - UPDATED for new columns
    totalSales() {
        return this.filteredData.reduce((sum, item) => sum + (item.Total_Sales || 0), 0);
    },

    // Unique locations
    uniqueLocations() {
        const locations = new Set();
        this.filteredData.forEach(item => locations.add(item.Location));
        return Array.from(locations);
    }
    },
    async mounted() {
    try {
        if (!this.user && this.getUser) {
            this.user = this.getUser();
        }

        try {
        const rawLocations = await apiHandler(() => Api.user[this.user.id].locations.Get());
        this.allowedIds = rawLocations.map(id => String(id));

    // 1. Filter the options
        this.myLocations = this.locationOptions.filter(item => {
            if (this.user.level === 7) {
                return true; // Admins get all locations
            }
            const locNumber = item.number; // Use the pre-parsed location number from the options
            return locNumber && this.allowedIds.includes(String(locNumber));
        });

        this.filters.location = this.myLocations[0].value; // Default to "All Locations" or first available
        
        } catch (error) {
        console.error('Error fetching user locations:', error);
        }
        finally {
            await this.fetchData();
        }
    } catch (error) {
        console.error('❌ Connection failed:', error);
    }
    },
    methods: {
    getSelectedLocationId() {
        const selectedCode = this.filters.location || '';
        const match = selectedCode.match(/^cs(\d{3})~/i);
        return match ? parseInt(match[1], 10) : null;
    },

    async getSelectedWeekData() {
        if (!this.filters.startDate) {
        return null;
        }

        const selectedDate = DateTime.fromISO(this.filters.startDate);
        if (!selectedDate.isValid) {
        return null;
        }

        return apiHandler(() => Api.weeks[selectedDate.weekYear][selectedDate.weekNumber].Get());
    },
    addDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.plus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    subtractDay() {
      const startDate = DateTime.fromISO(this.filters.startDate);
      const endDate = DateTime.fromISO(this.filters.endDate);
      
      this.filters.startDate = startDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
      this.filters.endDate = endDate.minus({ days: 1 }).toFormat('yyyy-MM-dd');
    },
    exportToCSV() {
        if (!this.filteredData.length) {
        this.$bvToast.toast('No data to export', {
            title: 'Export Error',
            variant: 'warning',
            solid: true
        });
        return;
        }

        try {
        // Use your table fields for headers and column order
        const headers = this.fields.map(field => field.label);
        const keys = this.fields.map(field => field.key);
        
        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        // Add rows
        this.filteredData.forEach(item => {
            const row = keys.map(key => {
            const value = item[key] || '';
            
            // Handle different data types
            if (value === null || value === undefined) {
                return '';
            }
            
            // Format numbers (remove currency formatting for CSV)
            if (typeof value === 'number') {
                // Format to 2 decimal places
                return value.toFixed(2);
            }
            
            // Handle strings that might contain commas or quotes
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                // Escape quotes and wrap in quotes
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            
            return stringValue;
            });
            
            csvContent += row.join(',') + '\n';
        });

        // Create and trigger download
        this.downloadCSV(csvContent, 'sales-data');
        
        } catch (error) {
        console.error('Error exporting CSV:', error);
        this.$bvToast.toast('Failed to export CSV: ' + error.message, {
            title: 'Export Error',
            variant: 'danger',
            solid: true
        });
        }
    },

    downloadCSV(csvContent, baseFilename) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        // Create filename with timestamp
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:]/g, '-');
        const filename = `${baseFilename}_${timestamp}.csv`;
        
        if (navigator.msSaveBlob) {
        // For IE/Edge
        navigator.msSaveBlob(blob, filename);
        } else {
        // For other browsers
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        }
    },
    dateDisabled(ymd, date) {
        const weekday = date.getDay();      // Return `true` if the date should be disabled
        return weekday === 1 || weekday === 2 || weekday === 3 || weekday === 4 || weekday === 5 || weekday === 6;
    },
    handleMenuChange(menuName) {
        this.activeMenu = menuName;
    },
    formatDate(date) {
        return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
    },
    async fetchWestland(startDate, endDate) {
      try {
        const requestBody = {
          startDate: startDate + "T00:00:00.000Z",
          endDate: endDate + "T23:59:59.999Z",
          location : 10
        };

        const orderData = await apiHandler(() => Api.orders.Post(requestBody));
        const countData = await apiHandler(() => Api.orders[requestBody.startDate][requestBody.endDate][requestBody.location].Get());

        const orderTotal = orderData.reduce((s, d) => s + d.data.reduce((ds, i) => ds + +i.totalAmount, 0), 0);
        const orderCount = countData.reduce((sum, item) => sum + item.uniqueOrderCount, 0);
        
        return {
          total: orderTotal, 
          count: orderCount
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching orders:", error);
      }
    },
    async fetchData() {
        this.loading = true;
        try {
        this.tableData = await apiHandler(() => 
            Api.clickhouse.timelineSnapshot.Get({
            location: this.filters.location,
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
            intervalVal: this.filters.age,
            intervalUnit: this.filters.interval
            })
        );

        if (this.filters.location === 'cs010~cc0cab7dc43218119bb8cf2f298860611' || this.filters.location === 'admin') {
          const currentWestland = await this.fetchWestland(this.filters.startDate, this.filters.endDate);
          const historicalWestland = await this.fetchWestland(
            DateTime.fromISO(this.filters.startDate).minus({ [this.filters.interval + 's']: this.filters.age }).toFormat('yyyy-MM-dd'),
            DateTime.fromISO(this.filters.endDate).minus({ [this.filters.interval + 's']: this.filters.age }).toFormat('yyyy-MM-dd')
          );
          
          console.log('CLICKHOUSE COUNT: ', this.tableData[0].Order_Count);
          console.log('WESTLAND COUNT: ', currentWestland.count);
          
          /* eslint-disable dot-notation */
          this.tableData.forEach(row => {
            if (row.Period === 'Current') {
              row['In_Store'] = Number(row['In_Store'] || 0) + Number(currentWestland.total);
              // Use Number() to ensure math addition, not string concatenation
              row['Order_Count'] = Number(row['Order_Count'] || 0) + Number(currentWestland.count);
              row['Total_Sales'] = Number(row['Total_Sales'] || 0) + Number(currentWestland.total);
            } else if (row.Period === 'Historical') {
              row['In_Store'] = Number(row['In_Store'] || 0) + Number(historicalWestland.total);
              row['Order_Count'] = Number(row['Order_Count'] || 0) + Number(historicalWestland.count);
              row['Total_Sales'] = Number(row['Total_Sales'] || 0) + Number(historicalWestland.total);
            }
          });
        }


        } catch (error) {
        console.error('Error fetching data:', error);
        this.connectionError = error.message;
        } finally {
        this.loading = false;
        }
    }
    }
    };
</script>
  
<style scoped>
    .sales-cell {
    background-color: red !important;
    font-weight: bold;

    }
    .main-container {
    /* min-height: 100vh; */
    padding: 0.5rem 0rem 0.5rem 0rem;
    }

    .main-content {
    flex-grow: 1;
    min-width: 0;
    margin: 0 1em;
    padding: 0em;
    overflow: visible; /* Prevent clipping at the main container level */
    }

    .content-card {
    border-radius: 0.5em !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    border: none;
    /* background-color: aquamarine; */
    width: 100%;
    margin: 0em;
    padding: 0em;
    }

    .touchpoint-dashboard {
    height: 100%;
    max-width: 1400px;
    padding: 0;
    }

    .dashboard-card {
    border-radius: inherit;
    /* background-color: violet; */
    width: 100%;
    margin: 0em;
    padding: 0em;
    padding: 1em 1em 0em 1em;

    }

    .card-body {
    padding: 0em;
    }

    .dashboard-header {
    padding-left: 0.5em;
    padding-right: 0.5em;
    }

    .sales-data {
    height: 25em;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    /* overflow: hidden; */
    width: 100%;
    }

    .origin-card {
    transition: all 0.3s ease;
    min-height: 4em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    }

    .origin-card:hover {
    /* transform: translateY(-5px); */
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }
    .origin-card.bg-primary {
    background-color: #3e187a;
    background-image: linear-gradient(316deg, #3e187a 0%, #994ecc 74%);
    }

    .origin-card.bg-success {
    background-color: #ffb347;
    background-image: linear-gradient(316deg, #F25424 0%, #ffc415 74%);
    }

    .origin-card.bg-info {
    background-color: #990000;
    background-image: linear-gradient(316deg, #990000 0%, #ff0000 74%);
    }

    .origin-card.bg-warning {
    background: rgb(0,127,255);
    background: linear-gradient(316deg, #2a52be 0%, #2391ff 74% );
    }

    .data-square {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    position: relative;
    overflow: visible !important; /* Ensure this is visible */    }

    /* New styles for data visualization */
    .top-store-card {
    border-left: 3px solid #28A745;
    }

    .worst-store-card {
    border-left: 3px solid #DC3545;
    }

    .store-icon {
    flex-shrink: 0;
    }

    .store-info {
    flex-grow: 1;
    }

    .legend-item {
    display: flex;
    align-items: center;
    margin-right: 15px;
    }

    .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid rgba(0,0,0,0.2);
    }

    .legend-color.stars {
    background-color: rgba(255, 215, 0, 0.7);
    }

    .legend-color.plow-horses {
    background-color: rgba(144, 238, 144, 0.7);
    }

    .legend-color.puzzles {
    background-color: rgba(135, 206, 250, 0.7);
    }

    .legend-color.dogs {
    background-color: rgba(255, 99, 132, 0.7);
    }

    .legend-text {
    font-size: 12px;
    font-weight: 500;
    }

    .clearfix {
    clear: both;
    }

    .sales-table {
      width: 100%;
      margin-top: 0px;
      margin-bottom: 0;
      border: 0px solid whitesmoke !important;
      border-radius: 10px;
      font-size: 1em !important;
    }

    .sales-table thead th {
      border: 0px solid whitesmoke !important;
      font-weight: 500;
    }
    .sales-table > thead > tr {
      border: 0px;
      background-color: ghostwhite !important;
    }

    .fixed-layout-table {
      table-layout: fixed !important; /* Forces columns to follow the width we set in fields */
      width: 100% !important;
    }

    .sales-table th, .sales-table td {
      padding: 0px !important;
      text-align: right; /* Aligns data to the right to match the stat boxes */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* Keep the first column (names) left-aligned */
    .sales-table th:first-child, 
    .sales-table td:first-child {
      text-align: left;
    }

    .sales-table tbody {
      padding: 0px !important;
    }

    .loading-indicator {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    margin-left: 10px;
    }

    .spinning-icon {
    animation: spin 1s linear infinite;
    }

    @keyframes spin {
    to { transform: rotate(360deg); }
    }

    .dashboard-icon {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    opacity: 0.8;
    }

    .menu-icon {
    font-size: 1rem;
    opacity: 0.8;
    }
    .side-nav {
    width: 11em;
    float: left;
    flex-shrink: 0;
    height: fit-content;
    }
    @media (max-width: 899.98px) {
        .side-nav {
            width: 100%;
            position: absolute;
            z-index: 1000; 
            margin-bottom: 1em;
            top: 55px;
        }
            .main-content {
            margin-top: 2em;
        }
    }

    .side-search{
    position: absolute;
    bottom: 0px;
    left: 1em;
    right: 1em;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2); 
    border-radius: 10px;
    border: none;
    padding: 0em;
    }
    .side-search > .my-search {
    border: 0em !important;
    height: 3em !important;
    }
</style>